WiseMetering.Views.ExportOrganizationData = WiseMetering.Views.Modal.Custom.extend({
    buttons: ['ok', 'cancel'],
    className: 'mbx-info text-left',
    template: 'templates/organizations/export_organization_data',
    title: () => i18next.t('export_organization_data.title'),
    width: 400,

    ok: function () {
        const
            type = this.$('#type-select').val(),
            organizationId = WiseMetering.currentOrganization.id,
            url = type === 'all'
                ? `${WiseMetering.apiUrl}/organizations/${organizationId}/list_entities`
                : `${WiseMetering.apiUrl}/${type}/list?organization_id=${organizationId}`;

        window.open(url, '_self');
        this.close();
    }
});
